// extracted by mini-css-extract-plugin
export default {"inputWrap":"input_inputWrap__ThD8P","error":"input_error__Imnu8","checkbox":"input_checkbox__ZxEJJ"};